import { Injectable } from '@angular/core';
import { DataIndex } from 'app/models/data-index.model';

@Injectable({
  providedIn: 'root'
})
export class InterlayerDataService {

	refDataIndex = new DataIndex();
	sbjDataIndex = new DataIndex();
	constructor() { }
}
